import reduce from "lodash/reduce";
import React, { FunctionComponent, useRef } from "react";
import { useIntl } from "react-intl";
import CartInput from "@Components/atoms/cart/CartInput";
import { useScript } from "@Hooks/useScript";
import { AutoCompletePlace } from "@Types/addresses";
import "./style.scss";

interface Props {
  onChange: (value: string) => void;
  onSelect: (place: AutoCompletePlace) => void;
  value: string | undefined;
}

const CartAutoCompleteStreetInput: FunctionComponent<Props> = ({ onChange, onSelect, value }) => {
  const intl = useIntl();
  const googleApiUrl = process.env.REACT_APP_GOOGLE_PLACES_API_KEY
    ? `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACES_API_KEY}&libraries=places`
    : undefined;
  const [error, loaded] = useScript(googleApiUrl);
  const autocompleteInput = useRef<HTMLInputElement>(null);

  if (
    loaded &&
    !error &&
    window.google &&
    autocompleteInput.current !== null &&
    !autocompleteInput.current.classList.contains("pac-target-input")
  ) {
    // Linting exception for google
    /*global google*/
    const autocomplete = new google.maps.places.Autocomplete(autocompleteInput.current, {
      fields: ["address_component", "geometry"],
      types: ["geocode"],
    });

    const handleChangePlace = () => {
      const place = autocomplete.getPlace();
      const position = {
        lat: place.geometry ? place.geometry.location.lat() : undefined,
        lng: place.geometry ? place.geometry.location.lng() : undefined,
      };

      const placeElements = ["country", "locality", "postal_code", "route", "street_number"];

      const selectedPlace = reduce(
        place.address_components,
        (result, component) => {
          const typeElement = placeElements.find((element) => {
            return component.types.includes(element);
          });
          if (typeElement) {
            result = {
              ...result,
              [typeElement]: typeElement === "country" ? component.short_name : component.long_name,
            };
          }
          return result;
        },
        {
          country: "",
          locality: "",
          postal_code: "",
          route: "",
          street_number: "",
        }
      );

      onSelect({ ...selectedPlace, position });
    };

    autocomplete.addListener("place_changed", handleChangePlace);
  }

  return (
    <div className="CartAddress">
      <CartInput
        autocomplete="shipping street-address"
        name="street"
        onChange={onChange}
        placeholder={intl.formatMessage({ id: "cheerz_CartAddressForm_street" })}
        ref={autocompleteInput}
        required={true}
        value={value}
      />
    </div>
  );
};

export default CartAutoCompleteStreetInput;
